export default __webpack_public_path__ + "static/media/sand.1955ecc2.png";